import { TypeGuard } from '../../shared';
import { ChatDataTypes } from './chat-data';

export interface QueueHandledReport {
  handledCalls: QueueHandledData[];
  type: string;
}

export interface QueueHandledData {
  abn: string;
  group: string;
  handled: number;
  type: 'ibqueue-handled';
}

export const isIBHandled: TypeGuard<ChatDataTypes, QueueHandledReport> = (
  data: ChatDataTypes
): data is QueueHandledReport =>
  (data && data.type === 'ibqueue-handled') || false;
